/** Marketing / landing home route (MainLayout). */
export const HOME_PATH = '/';
